import EventNames from '../constants/EventNames';

/**
 * Simulate that the page is loaded
 */
export function domLoad() {
  eventFire(window, EventNames.LOAD);
}

/**
 * Simulate a click
 */
export function click(element) {
  if (element instanceof HTMLInputElement && ['checkbox', 'radio'].includes(element.getAttribute('type'))) {
    if (element.checked) {
      element.removeAttribute('checked');
    } else {
      element.setAttribute('checked', 'true');
    }
  }

  eventFire(element, EventNames.CLICK);
}

/**
 * Simulate an input change
 */
export function change(element) {
  eventFire(element, EventNames.CHANGE);
}

/**
 * Simulate a focus on an input
 */
export function focus(element) {
  eventFire(element, EventNames.FOCUS);
}

/**
 * Simulate a blur on an input
 */
export function blur(element) {
  eventFire(element, EventNames.BLUR);
}

/**
 * Simulate input on an input field
 */
export function input(element) {
  eventFire(element, EventNames.INPUT);
}

/**
 * Simulate typing on an input
 */
export function type(element, value) {
  element.value = value;
  eventFire(element, EventNames.INPUT);
}

/**
 * Simulate a mouse enter
 */
export function mouseEnter(element) {
  eventFire(element, EventNames.MOUSE_ENTER);
}

/**
 * Simulate a mouse over
 */
export function mouseOver(element) {
  eventFire(element, EventNames.MOUSE_OVER);
}

/**
 * Simulate a mouse leave
 */
export function mouseLeave(element) {
  eventFire(element, EventNames.MOUSE_LEAVE);
}

/**
 * Simulate touchStart event on an element
 */
export function touchStart(element) {
  eventFire(element, EventNames.TOUCH_START);
}

/**
 * Simulate a mouse down
 */
export function mouseDown(element, options = {}) {
  element.dispatchEvent(new MouseEvent(EventNames.MOUSEDOWN, {
    bubbles: options.bubbles || true,
    clientX: options.clientX || 0,
    clientY: options.clientY || 0
  }));
}

/**
 * Simulate a mouse up
 */
export function mouseUp(element, options = {}) {
  element.dispatchEvent(new MouseEvent(EventNames.MOUSEUP, {
    bubbles: options.bubbles || true,
    clientX: options.clientX || 0,
    clientY: options.clientY || 0
  }));
}

/**
 * Simulate a submit
 */
export function submit(element) {
  eventFire(element, EventNames.SUBMIT);
}

/**
 * Simulate a toggle on a checkbox
 */
export function toggleCheckbox(element) {
  element.checked = !element.checked;
  eventFire(element, EventNames.CHANGE);
}

/**
 * Simulate a toggle on a radio button
 */
export function toggleRadio(element) {
  element.checked = true;
  eventFire(element, EventNames.CHANGE);
}

/**
 * Simulate a scroll
 */
export function scroll() {
  eventFire(document, EventNames.SCROLL);
}

/**
 * Simulate a enter press
 */
export function enter(element) {
  const event = new Event(EventNames.KEY_UP, { bubbles: true });
  event.keyCode = 13;
  event.key = 'Enter';
  element.dispatchEvent(event);
}

/**
 * Simulate a keyUp
 */
export function keyUp(element, value, key = null) {
  const event = new Event(EventNames.KEY_UP, { bubbles: true });
  event.key = key || value;

  element.value = value;
  element.dispatchEvent(event);
}

/**
 * Simulate a keyDown
 */
export function keyDown(element, value, key = null) {
  const event = new Event(EventNames.KEY_DOWN, { bubbles: true });
  event.key = key || value;

  element.value = value;
  element.dispatchEvent(event);
}

/**
 * Fire an event
 */
export function eventFire(element, eventType) {
  if (element.fireEvent) {
    element.fireEvent('on' + eventType);
  } else {
    const eventObject = document.createEvent('Events');
    eventObject.initEvent(eventType, true, false);
    element.dispatchEvent(eventObject);
  }
}

/**
 * Simulate a swipe to the left
 */
export function swipeLeft(hammerManager) {
  hammerManager.emit(EventNames.SWIPE_LEFT, {});
}

/**
 * Simulate a double tap on an element
 */
export function doubleTap(hammerManager) {
  hammerManager.emit(EventNames.DOUBLE_TAP, {});
}

/**
 * Get the parameters from a given mock
 */
export function getMockParams(mock) {
  const latestCall = mock.mock.calls[mock.mock.calls.length - 1] || null;
  if (!latestCall) {
    throw new Error('No notification received');
  }
  return latestCall[0];
}

/**
 * Get the last call of a mock
 */
export function getLastCallOfMock(mock) {
  return mock.mock.calls[mock.mock.calls.length - 1];
}

/**
 * Generate a number from the given price
 */
export function priceToNumber(price: string): number {
  return price.split(',').map(str => str.replace(/[^\d]/g, '')).join('.');
}
